import React from "react";
import './ServicesSection.css'
import ServicesSlider from "../Sliders/ServiceSlider/ServicesSlider";
const ServicesSection =()=>{
    return(
        <section className="ServicesSection">
            <div className="container CustomContainer">
                <div className="ServicesHeader">
                    <h1>Our Services</h1>
                    <span className="ServicesDescription"> MIND: A journey from media to tech. Established in 2010, we›ve expanded from <br />
                    radio and TV to encompass digital solutions, retail, and tech services</span>
                </div>
            </div>

            <ServicesSlider/>
        </section>
    );
}
export default ServicesSection;